import React from "react";
import intl from "react-intl-universal";
import {deleteTable} from "prosemirror-tables";


import {ArrowUpIcon} from "../../../../components/icons/editor/ArrowUpIcon";
import {ArrowLeftIcon} from "../../../../components/icons/editor/ArrowLeftIcon";
import {ArrowRightIcon} from "../../../../components/icons/editor/ArrowRightIcon";
import {ArrowDownIcon} from "../../../../components/icons/editor/ArrowDownIcon";
import {DeleteIcon} from "../../../../components/icons/DeleteIcon";
import {MinimizeIcon} from "../../../../components/icons/editor/MinimizeIcon";
import {MaximizeIcon} from "../../../../components/icons/editor/MaximizeIcon";
import {DownloadIcon} from "../../../../components/icons/DownloadIcon";

import {insertColumnBefore} from "../../../../../Editor/module/commands/table/insertColumnBefore";
import {insertColumnAfter} from "../../../../../Editor/module/commands/table/insertColumnAfter";
import {insertRowUp} from "../../../../../Editor/module/commands/table/insertRowUp";
import {insertRowDown} from "../../../../../Editor/module/commands/table/insertRowDown";
import {deleteRow} from "../../../../../Editor/module/commands/table/deleteRow";
import {deleteColumn} from "../../../../../Editor/module/commands/table/deleteColumn";
import {canMaximizeTable, maximizeTable} from "../../../../../Editor/module/commands/table/maximizeTable";
import {canMinimizeTable, minimizeTable} from "../../../../../Editor/module/commands/table/minimizeTable";
import {exportTableCsv} from "../../../../../Editor/module/commands/table/exportTableCsv";

import {GroupedActions, ContextAction} from "../utils/GroupedActions";
import {ContextMenuInterface} from "../../ContextMenuInterface";


export interface TableToolbarProps extends ContextMenuInterface {
}

const insertActions: ContextAction[] = [
    {
        id: 'insertRowUp',
        Icon: ArrowUpIcon,
        getTitle: () => intl.get('table-toolbar.insert_row_above').d('Insert row above'),
        action: insertRowUp,
    },
    {
        id: 'insertRowDown',
        Icon: ArrowDownIcon,
        getTitle: () => intl.get('table-toolbar.insert_row_below').d('Insert row below'),
        action: insertRowDown,
    },
    {
        id: 'insertColumnLeft',
        Icon: ArrowLeftIcon,
        getTitle: () => intl.get('table-toolbar.insert_column_left').d('Insert column left'),
        action: insertColumnBefore,
    },
    {
        id: 'insertColumnRight',
        Icon: ArrowRightIcon,
        getTitle: () => intl.get('table-toolbar.insert_column_right').d('Insert column right'),
        action: insertColumnAfter,
    },
]
const deleteActionsGroup: ContextAction[] = [
    {
        id: 'deleteRow',
        Icon: DeleteIcon,
        getTitle: () => intl.get('table-toolbar.delete_row').d('Delete row'),
        action: deleteRow,
    },
    {
        id: 'deleteColumn',
        Icon: DeleteIcon,
        getTitle: () => intl.get('table-toolbar.delete_column').d('Delete column'),
        action: deleteColumn,
    },
    {
        id: 'deleteTable',
        Icon: DeleteIcon,
        getTitle: () => intl.get('table-toolbar.delete_table').d('Delete table'),
        action: deleteTable,
    },
]
const tableActions: ContextAction[] = [
    {
        id: 'maximizeTable',
        Icon: MaximizeIcon,
        getTitle: () => intl.get('table-toolbar.maximize').d('Maximize'),
        action: maximizeTable,
        enable: canMaximizeTable,
    },
    {
        id: 'minimizeTable',
        Icon: MinimizeIcon,
        getTitle: () => intl.get('table-toolbar.minimize').d('Minimize'),
        action: minimizeTable,
        enable: canMinimizeTable,
    },
    {
        id: 'exportCsv',
        Icon: DownloadIcon,
        getTitle: () => intl.get('table-toolbar.export_csv').d('Export CSV'),
        action: exportTableCsv,
    },
];

const groupedActions: ContextAction[][] = [
    insertActions,
    deleteActionsGroup,
    tableActions,
];


export const TableToolbar = ({handleClose, isDark, ...specificParams}: TableToolbarProps) => {
    return <GroupedActions
        handleClose={handleClose}
        actionGroups={groupedActions}
        additionalParams={specificParams}
        isDark={isDark}
    />
}
